<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "app",
};
</script>

<style>
@font-face {
  font-family: "NotoSansJP";
  src: url("@/assets/fonts/NotoSansJP-Regular.otf") format("opentype");
}

body {
  font-family: "NotoSansJP", sans-serif;
}
</style>
